import PropTypes from 'prop-types';
import React from 'react';
import ToolTip, {tooltipPositions} from '../../../components/ToolTip.jsx';

const SummaryHeader = ({title, icon, description, tooltip, link}) => {
  return (
    <div className='report-block'>
      <div className='row'>
        <div className='col-sm-12'>
          <h3 className='report-block-title'>
            <i className={'icon-blue bl ' + icon}/>
            <a className='report-block-title-text'
              onClick={() => window.location = link}>
              {title}
              {tooltip ?
                <ToolTip title={tooltip} position={tooltipPositions.topRight} iconOnly /> :
                null}
            </a>
          </h3>
          <div className='description'>{description}</div>
        </div>
      </div>
    </div>
  );
};

SummaryHeader.propTypes = {
  title: PropTypes.any.isRequired,
  icon: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  expanded: PropTypes.bool,
  tooltip: PropTypes.string,
  link: PropTypes.string,
};

export default SummaryHeader;
